export const NAME = 'framework';
